module.exports = __webpack_public_path__ + "static/img/016.95bf179.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-head/016.png
// module id = 4UqK
// module chunks = 1